import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface TeamMember {
  uid: string;
  name: string | null;
  email: string;
  role: string;
}

export function useTeamMembers() {
  return useQuery({
    queryKey: ['team-members'],
    queryFn: async () => {
      const response = await api.team.members();
      return response.members as TeamMember[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
